var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"air-footer-bar flex jbetween acenter",class:{ 'sidebar-collapse': _vm.$sidebarCollapse, jend: _vm.jend }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }